import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  GetAllCityOfState,
  getBuyerRolesAction,
  getGstDetails,
  getLocationAndPincodeAction,
  getPanDetails,
  getpricingGeographyAction,
  onboardThroughExistingUser,
} from '../Onboarding/auth/action';
import { GetAllStates } from '../../screen/auth/action/util_actions';
import { useNavigate, useLocation } from 'react-router-dom';
import { IDLength, SupplierModuleTypeEnum } from '../../utils/settings';
import { alphabeticRegex, validateIsAlphaNumeric } from '../Utils';
import { getCompanySuppliersAction } from '../APIs/action';

const OnboardBuyer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [companyList, setCompanyList] = useState([]);
  const [onboardBuyerRoleData, setOnboardBuyerRoleData] = useState(null);
  const [selectedRoleData, setSelectedRoleData] = useState(null);
  const [tabValue, setTabValue] = useState(null);
  const [companyTabValue, setCompanyTabValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const isFromSearchStp = location?.state?.isFromSearchStp || false;
  const [allPincodes, setAllPincodes] = useState([]);
  const [allCities, setAllCities] = useState([]);

  const [obj, setObj] = useState({
    phone_number: '',
    email: '',
    firstname: '',
    lastname: '',
    company_name: '',
    company_gstin: '',
    company_address: '',
    company_pincode: '',
    pancard_no: '',
    state_name: '',
    state_id: '',
    district_name: '',
    district_id: '',
    region_role_id: '',
    firm_role_id: '',
    privacy_policy_accept_status: true,
    address_line_1: '',
    address_line_2: '',
    address_line_3: '',
    location_id: '',
    location_name: '',
    pricing_geography_id: '',
  });
  const [errors, setErrors] = useState({});
  const getCompany = async () => {
    const { error, data, message } = await getCompanySuppliersAction(
      SupplierModuleTypeEnum.onboarding_enabled,
    );
    if (!error && data && Array.isArray(data.suppliers_list)) {
      setCompanyList(
        data.suppliers_list.map((item) => ({
          label: item.name,
          value: item.id,
          key: item.id,
        }))
      );
    } else {
      toast.error(message);
    }
  };
  const getOnboardBuyerRoles = async () => {
    const { data, error, message } = await getBuyerRolesAction(
      Number(companyTabValue),
      false,
      true,
    );
    if (!error) {
      setOnboardBuyerRoleData(data);
    } else {
      toast.error(message);
    }
  };
  const [firstSelection, setFirstSelection] = useState(null);
  const getlocationPincode = async (districtId, locationId = null, PincodeId = null) => {
    if (PincodeId && obj.location_id) return;
    if (locationId && obj.company_pincode) return; 
    const { data, error } = await getLocationAndPincodeAction(districtId, { location_id: locationId, pincode_id: PincodeId });
      if (!error) {
        if (locationId && !obj.company_pincode) {
          setAllPincodes(
            data.pincode_list.map((pincode) => ({
              label: pincode.pincode_name,
              value: pincode.pincode_id,
            }))
          );
        } else if (PincodeId && !obj.location_id) {
          setAllCities(
            data.location_list.map((city) => ({
              label: city.location_name,
              value: city.location_id,
            }))
          );
        } else if(!locationId && !PincodeId) {
          setAllPincodes(
            data.pincode_list.map((pincode) => ({
              label: pincode.pincode_name,
              value: pincode.pincode_id,
            }))
          );
          setAllCities(
            data.location_list.map((city) => ({
              label: city.location_name,
              value: city.location_id,
            }))
          );
        }
      }
  };
  useEffect(() => {
    getCompany();
  }, []);

  useEffect(() => {
    if (companyTabValue) {
      getOnboardBuyerRoles();
    }
  }, [companyTabValue]);

  const handleTabChange = (event) => {
    const roleData = onboardBuyerRoleData.roles.find(
      (role) => role.firm_role_id === event.target.value,
    );
    setSelectedRoleData(roleData);
    setTabValue(event.target.value);
  };
  const handleCompanyTabChange = (event) => {
    setSelectedRoleData(null);
    setTabValue(null);
    setObj({
      phone_number: '',
      email: '',
      firstname: '',
      lastname: '',
      company_name: '',
      company_gstin: '',
      company_address: '',
      company_pincode: '',
      pancard_no: '',
      state_name: '',
      state_id: '',
      district_name: '',
      district_id: '',
      region_role_id: '',
      firm_role_id: '',
      privacy_policy_accept_status: true,
      address_line_1: '',
      address_line_2: '',
      address_line_3: '',
      location_id: '',
      location_name: '',
      pricing_geography_id: '',
    });
    setCompanyTabValue(event.target.value);
  };
  const [districts, setDistricts] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [pricingGeographyList, setPricingGeographyList] = useState([]);
  const getStates = async () => {
    const { data, error, message } = await GetAllStates();
    if (!error) {
      setStateData(
        data.map((state) => ({ label: state.state_name, value: state.id })),
      );
    } else {
      toast.error(message);
    }
  };
  const getDistricts = async () => {
    const stateId = obj.state_id;

    const { data, error } = await GetAllCityOfState(stateId);

    if (!error) {
      setDistricts(
        data.map((district) => ({
          label: district.district_name,
          value: district.id,
        })),
      );
    }
  };

  const getGeographyPricing = async (company_id, district_id) => {
    const params = new URLSearchParams();
    params.append('district_id', district_id);
    params.append('manufacturer_id', company_id);

    const { data, error, message } = await getpricingGeographyAction(params);

    if (!error) {
      setPricingGeographyList(
        data.map((vv) => ({
          label: vv.pricing_geography_name,
          value: vv.pricing_geography_id,
        })),
      );
    } else return toast.error(message);
  };
  useEffect(() => {
    if (companyTabValue && obj?.district_id) {
      getGeographyPricing(companyTabValue, obj.district_id);
    }
  }, [companyTabValue, obj.district_id]);

  useEffect(() => {
    getStates();
  }, []);

  useEffect(() => {
    if (obj.state_id) {
      getDistricts();
    }
  }, [obj.state_id]);

 

  const onGstBlur = async (e) => {
    if (e.target.value.length !== IDLength['GST']) return;
    const { error, message, data } = await getGstDetails(e.target.value);
    if (error) {
      toast.error(message);
    } else {
      setObj({
        ...obj,
        company_name: data.company_name || '',
        company_address: data.street || '',
        company_pincode: data.pincode_id || '',
        state_id: data.state_id || '',
        district_id: data.district_id || '',
        company_gstin: e.target.value,
        pancard_no: data.pancard_no || '',
        address_line_1: data.address_line_1 || '',
        address_line_2: data.address_line_2 || '',
        address_line_3: data.address_line_3 || '',
        location_id: data.location_id || '',
        location_name: data.location_name || '',
        pricing_geography_id: '',
      });
      if(data.pincode_id) {
        getlocationPincode(data.district_id);
        getlocationPincode(data.district_id, null, data.pincode_id);
        setFirstSelection('pincode')
      }
    }
  };
  const onPanBlur = async (e) => {
    if (e.target.value.length !== IDLength['PAN']) return;
    const { error, message, data } = await getPanDetails(e.target.value);
    if (error) {
      toast.error(message);
    } else {
      setObj({
        ...obj,
        company_name: data.company_name || '',
        company_address: data.street || '',
        company_pincode: data.company_pincode || '',
        state_id: data.state_id || '',
        district_id: data.district_id || '',
        pancard_no: e.target.value,
        address_line_1: data.address_line_1 || '',
        address_line_2: data.address_line_2 || '',
        address_line_3: data.address_line_3 || '',
        location_id: data.location_id || '',
        location_name: data.location_name || '',
        pricing_geography_id: '',
      });
      if(data.pincode_id) {
        getlocationPincode(data.district_id);
        getlocationPincode(data.district_id, null, data.company_pincode);
        setFirstSelection('pincode')
      }
    }

  };
  const gstPanRequired = selectedRoleData?.onboarding_config?.is_gst_required || selectedRoleData?.onboarding_config?.is_pan_required
  const validateForm = () => {
    let valid = true;
    let newErrors = {};

    if (!obj.phone_number) {
      newErrors.phone_number = 'Phone Number is required';
      valid = false;
    } else if (obj.phone_number.length !== 10) {
      newErrors.phone_number = 'Phone Number must be 10 digits';
      valid = false;
    }
    if (!obj.firstname) {
      newErrors.firstname = 'Please enter First Name';
      valid = false;
    }
    if (!obj.company_pincode) {
      newErrors.company_pincode = 'Please select Pincode';
      valid = false;
    }

    if (!obj.location_id) {
      newErrors.location_id = 'Please select City';
      valid = false;
    }
    if (!obj.district_id) {
      newErrors.district_id = 'Please select District';
      valid = false;
    }
    if (!obj.state_id) {
      newErrors.state_id = 'Please select State';
      valid = false;
    }
    if (!obj.address_line_1) {
      newErrors.address_line_1 = 'Please Enter Address Line 1';
      valid = false;
    }

    if (
      gstPanRequired && !obj.pricing_geography_id
    ) {
      newErrors.pricing_geography_id = 'Please select Pricing Geography';
      valid = false;
    }
    if (gstPanRequired ) {
      if (!obj.company_gstin) {
        newErrors.company_gstin = 'Please enter GSTIN';
        valid = false;
      } else if (obj.company_gstin.length !== IDLength['GST']) {
        newErrors.company_gstin = 'Please enter a valid GSTIN';
        valid = false;
      }
    }
    if ( gstPanRequired ) {
      if (!obj.pancard_no) {
        newErrors.pancard_no = 'Please enter PAN Card Number';
        valid = false;
      } else if (obj.pancard_no.length !== IDLength['PAN']) {
        newErrors.pancard_no = 'Please enter valid PAN Card Number';
        valid = false;
      }
    }
    if ( gstPanRequired && !obj.company_name) {
      newErrors.company_name = 'Please enter Company Name';
      valid = false;
    }
    
    setErrors(newErrors);
    return valid;
  };
  const handleOnSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    const payload = {
      phone_number: obj.phone_number,
      email: obj.email,
      firstname: obj.firstname,
      lastname: obj.lastname,
      company_address: {
        address_line_1: obj.address_line_1,
        address_line_2: obj.address_line_2,
        address_line_3: obj.address_line_3,
      },
      location_id: obj.location_id,
      pincode: obj.company_pincode,
      district_id: obj.district_id,
      privacy_policy_accept_status: true,
      firm_role_id: selectedRoleData.firm_role_id,
      region_role_id: selectedRoleData.region_role_id,
      manufacturer_id: companyTabValue,
      ...(gstPanRequired && obj.company_name &&  { company_name: obj.company_name }),
      ...(gstPanRequired && obj.company_gstin && { company_gstin: obj.company_gstin }),
      ...(gstPanRequired && obj.pancard_no && { pancard_no: obj.pancard_no }),
      ...(gstPanRequired && obj.pricing_geography_id && { pricing_geography_id: obj.pricing_geography_id}),
    };

    const { error, message } = await onboardThroughExistingUser(payload);
    setLoading(false);
    if (!error) {
      toast.success(message);
      if (isFromSearchStp) {
        setTimeout(() => {
          return navigate(-1);
        }, 1000);
      } else return navigate(0);
    } else {
      return toast.error(
        message ? message : 'Something went wrong, please try again later',
      );
    }
  };
  useEffect(() => {
    if(obj.company_gstin){
      const gstin = obj.company_gstin;
      if(gstin.length === IDLength['GST']){
        onGstBlur({target: {value: gstin}});
      }
    }
  }, [obj.company_gstin]);

  useEffect(() => {
    if(!obj.company_gstin && obj.pancard_no){
      const pan = obj.pancard_no;
      if(pan.length === IDLength['PAN']){
        onPanBlur({target: {value: pan}});
      }
    }
  }, [obj.company_gstin, obj.pancard_no]);

  useEffect(() => {
    if (obj?.district_id && !obj?.location_id && !obj?.company_pincode) {
      getlocationPincode(obj.district_id);
    }
  }, [obj.district_id]);
  
  useEffect(() => {
    if (obj?.district_id && obj?.location_id) {
      getlocationPincode(obj.district_id, obj.location_id, null);
    }
  }, [obj.location_id]);
  useEffect(() => {
    if (obj?.district_id && obj?.company_pincode) {
      getlocationPincode(obj.district_id, null, obj.company_pincode);
    }
  }, [obj.company_pincode]);

  return (
    <div>
      <Container
        maxWidth='true'
        sx={{ pl: '2rem', pt: '3rem' }}
      >
        <Box>
          <Typography variant='h4'>Onboard Buyer</Typography>
          <Divider sx={{ mt: '1rem', mb: '3rem' }} />
        </Box>

        <Box sx={{ width: '100%' }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={3}>
              <FormControl variant='outlined' fullWidth>
                <InputLabel id='state-label'>Select Company</InputLabel>
                <Select
                  labelId='state-label'
                  label='Select Company'
                  onChange={handleCompanyTabChange}
                  value={companyTabValue}
                > 
                  {companyList.map((item) => (
                    <MenuItem
                      key={item.value}
                      value={item.value}
                    >
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel id='state'>Select Role</InputLabel>
                <Select
                  label='Select Role'
                  onChange={handleTabChange}
                  value={tabValue}
                >
                  {onboardBuyerRoleData?.roles.length > 0 &&
                    onboardBuyerRoleData?.roles.map((item, index) => (
                      <MenuItem value={item?.firm_role_id}>
                        {item?.display_name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box sx={{ mt: '2rem' }} />

          {selectedRoleData && (
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Card sx={{ p: { xs:1, md:3 } }}>
                  <CardContent>
                    <Typography variant="h6">User Detail</Typography>
                    <Divider sx={{ my: "1rem" }} />
                    <Grid container spacing={2}>
                      {/* Phone Number */}
                      <Grid item xs={12}>
                        <FormControl error={!!errors.phone_number} fullWidth>
                          <TextField
                            required
                            fullWidth
                            id="phoneNumber"
                            label="Phone Number"
                            name="phoneNumber"
                            autoComplete="phoneNumber"
                            autoFocus
                            value={obj.phone_number}
                            onChange={(e) => {
                              const value = e.target.value;
                              const regex = /^[0-9]{0,10}$/;
                              if (regex.test(value)) {
                                setObj({ ...obj, phone_number: value });
                              }
                            }}
                            error={!!errors.phone_number}
                            helperText={errors.phone_number}
                          />
                        </FormControl>
                      </Grid>

                      {/* First Name */}
                      <Grid item xs={12}>
                        <FormControl error={!!errors.firstname} fullWidth>
                          <TextField
                            required
                            fullWidth
                            id="firstname"
                            label="First Name"
                            name="firstname"
                            autoComplete="firstname"
                            value={obj.firstname}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (alphabeticRegex.test(value)) {
                                setObj({ ...obj, firstname: value });
                              }
                            }}
                            error={!!errors.firstname}
                            helperText={errors.firstname}
                          />
                        </FormControl>
                      </Grid>

                      {/* Last Name */}
                      <Grid item xs={12}>
                        <FormControl fullWidth>
                          <TextField
                            fullWidth
                            id="lastname"
                            label="Last Name"
                            name="lastname"
                            autoComplete="lastname"
                            value={obj.lastname}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (alphabeticRegex.test(value)) {
                                setObj({ ...obj, lastname: value });
                              }
                            }}
                          />
                        </FormControl>
                      </Grid>

                      {/* Email */}
                      <Grid item xs={12}>
                        <FormControl fullWidth>
                          <TextField
                            fullWidth
                            id="email"
                            label="Email"
                            name="email"
                            autoComplete="email"
                            value={obj.email}
                            onChange={(e) => setObj({ ...obj, email: e.target.value })}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              {selectedRoleData && gstPanRequired && (
                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <Card sx={{ p: { xs:1, md:3 } }}>
                    <CardContent>
                      <Typography variant='h6'>Firm Detail</Typography>
                      <Divider sx={{ my: '1rem' }} />
                      <Grid container spacing={2} >
                        <Grid item xs={12}>
                          <FormControl error={!!errors.company_gstin} fullWidth>
                            <TextField
                              required={selectedRoleData?.onboarding_config?.is_gst_required}
                              fullWidth
                              id="company_gstin"
                              label="Company GSTIN"
                              name="company_gstin"
                              autoComplete="company_gstin"
                              value={obj.company_gstin}
                              onChange={(e) => {
                                const value = e.target.value.toUpperCase();
                                if (value === '' || validateIsAlphaNumeric(value)) {
                                  setObj({ ...obj, company_gstin: e.target.value });
                                }
                              }}
                              // onBlur={onGstBlur}
                              error={!!errors.company_gstin}
                              helperText={errors.company_gstin}
                              inputProps={{
                                style: { textTransform: 'uppercase' },
                                maxLength: IDLength['GST'],
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          <FormControl error={!!errors.pancard_no} fullWidth>
                            <TextField
                              required={selectedRoleData?.onboarding_config?.is_pan_required}
                              fullWidth
                              id="pancard_no"
                              label="Pancard No"
                              name="pancard_no"
                              autoComplete="pancard_no"
                              value={obj.pancard_no}
                              onChange={(e) => {
                                const value = e.target.value.toUpperCase();
                                if (value === '' || validateIsAlphaNumeric(value)) {
                                  setObj({ ...obj, pancard_no: e.target.value });
                                }
                              }}
                              error={!!errors.pancard_no}
                              helperText={errors.pancard_no}
                              // onBlur={onPanBlur}
                              inputProps={{
                                style: { textTransform: 'uppercase' },
                                maxLength: IDLength['PAN'],
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          <FormControl error={!!errors.company_name} fullWidth>
                            <TextField
                              required
                              fullWidth
                              id="company_name"
                              label="Company Name"
                              name="company_name"
                              autoComplete="company_name"
                              value={obj.company_name}
                              onChange={(e) => setObj({ ...obj, company_name: e.target.value })}
                              error={!!errors.company_name}
                              helperText={errors.company_name}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth error={!!errors.state_id}>
                            <InputLabel id="state">State</InputLabel>
                            <Select
                              label="State"
                              onChange={(e) => {
                                const selectedValue = e.target.value;
                                const selectedLabel = stateData.find((option) => option.value === selectedValue)?.label;
                                setObj({ ...obj, 
                                  state_id: selectedValue, 
                                  state_name: selectedLabel,
                                  district_id: '',
                                  district_name: '',
                                  company_pincode: null,
                                  location_id: null,
                                  location_name: "",
                                 });
                              }}
                              value={obj?.state_id || ''}
                            >
                              {stateData.map((state) => (
                                <MenuItem key={state.value} value={state.value}>{state.label}</MenuItem>
                              ))}
                            </Select>
                            {errors.state_id && <FormHelperText>{errors.state_id}</FormHelperText>}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth error={!!errors.district_id}>
                            <InputLabel id="district">District</InputLabel>
                            <Select
                              label="District"
                              value={obj?.district_id || ''}
                              onChange={(e) => {
                                const selectedValue = e.target.value;
                                const selectedLabel = districts.find((option) => option.value === selectedValue)?.label;
                                setObj({ ...obj, 
                                  district_id: selectedValue,
                                  district_name: selectedLabel,
                                  company_pincode: null,
                                  location_id: null,
                                  location_name: "",
                                });
                                setFirstSelection(null);
                              }}
                            >
                              {districts.map((district) => (
                                <MenuItem key={district.value} value={district.value}>{district.label}</MenuItem>
                              ))}
                            </Select>
                            {errors.district_id && <FormHelperText>{errors.district_id}</FormHelperText>}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          <FormControl
                            error={!!errors.address_line_1}
                            fullWidth
                          >
                            <TextField
                              required
                              fullWidth
                              id='address_line_1'
                              label='Address Line 1'
                              name='address_line_1'
                              autoComplete='address_line_1'
                              autoFocus
                              value={obj.address_line_1}
                              onChange={(e) =>
                                setObj({
                                  ...obj,
                                  address_line_1: e.target.value,
                                })
                              }
                              error={!!errors.address_line_1}
                              helperText={errors.address_line_1}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            error={!!errors.address_line_2}
                            fullWidth
                          >
                            <TextField
                              required
                              fullWidth
                              id='address_line_2'
                              label='Address Line 2'
                              name='address_line_2'
                              autoComplete='address_line_2'
                              autoFocus
                              value={obj.address_line_2}
                              onChange={(e) =>
                                setObj({
                                  ...obj,
                                  address_line_2: e.target.value,
                                })
                              }
                            />
                            {errors.address_line_2 && (
                              <FormHelperText>
                                {errors.address_line_2}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            error={!!errors.address_line_3}
                            fullWidth
                          >
                            <TextField
                              required
                              fullWidth
                              id='address_line_3'
                              label='Address Line 3'
                              name='address_line_3'
                              autoComplete='address_line_3'
                              autoFocus
                              value={obj.address_line_3}
                              onChange={(e) =>
                                setObj({
                                  ...obj,
                                  address_line_3: e.target.value,
                                })
                              }
                            />
                            {errors.address_line_3 && (
                              <FormHelperText>
                                {errors.address_line_3}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            error={!!errors.location_id}
                            fullWidth
                          >
                            <InputLabel id='city'>City</InputLabel>
                            <Select
                              label='City'
                              value={obj?.location_id || ""}
                              onChange={(e) => {
                                const selectedValue = e.target.value;
                                const selectedLabel = allCities.find((option) => option.value === selectedValue)?.label;
                                if(!firstSelection) setFirstSelection("city");
                                setObj({ ...obj, 
                                  location_id: selectedValue, 
                                  location_name: selectedLabel,
                                  ...(firstSelection === "city" ? { company_pincode: null } : {}),
                                });
                              }}
                            >
                              {allCities.map((city) => (
                                <MenuItem value={city.value}>
                                  {city.label}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.location_id && (
                              <FormHelperText>
                                {errors.location_id}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            fullWidth
                            error={!!errors.company_pincode}
                          >
                            <InputLabel id='district'>Pincode</InputLabel>
                            <Select
                              label='Pincode'
                              value={obj?.company_pincode || ""}
                              onChange={(e) => {
                                const selectedPincode = e.target.value;
                                if (!firstSelection) setFirstSelection("pincode");
                                setObj({
                                  ...obj,
                                  company_pincode: selectedPincode,
                                  ...(firstSelection === "pincode" ? { location_id: null, location_name: "" } : {}),
                                });
                              }}
                            >
                              {allPincodes.map((pincode) => (
                                <MenuItem value={pincode.value}>
                                  {pincode.label}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.company_pincode && (
                              <FormHelperText>
                                {errors.company_pincode}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          <FormControl error={!!errors.pricing_geography_id} fullWidth>
                            <InputLabel id='pricingGeo'>
                              Select Pricing Geography
                            </InputLabel>
                            <Select
                              label='Select Pricing Geography'
                              onChange={(e) => {
                                const selectedValue = e.target.value;
                                setObj({
                                  ...obj,
                                  pricing_geography_id: selectedValue,
                                });
                              }}
                              value={obj?.pricing_geography_id || ''}
                            >
                              {pricingGeographyList.map((geo) => (
                                <MenuItem value={geo.value}>
                                  {geo.label}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.pricing_geography_id && (
                              <FormHelperText>
                                {errors.pricing_geography_id}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              )}
              {selectedRoleData &&
                !selectedRoleData?.onboarding_config?.is_gst_required &&
                !selectedRoleData?.onboarding_config?.is_pan_required && (
                  <Grid
                    item
                    xs={12}
                    md={6}
                  > 
                    <Card sx={{ p: { xs:1, md:3 } }}>
                      <CardContent>
                        <Typography variant="h6">Geography Detail</Typography>
                        <Divider sx={{ my: "1rem" }} />
                        <Grid container spacing={2}>
                          {/* State & District */}
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth error={!!errors.state_id}>
                              <InputLabel>State</InputLabel>
                              <Select
                                label="State"
                                value={obj?.state_id || ""}
                                onChange={(e) => {
                                  const selectedValue = e.target.value;
                                  const selectedLabel = stateData.find((option) => option.value === selectedValue)?.label;
                                  setObj({ ...obj, 
                                    state_id: selectedValue,
                                    state_name: selectedLabel,
                                    district_id: '',
                                    district_name: '',
                                    company_pincode: null,
                                    location_id: null,
                                    location_name: "",
                                   });
                                }}
                              >
                                {stateData.map((state) => (
                                  <MenuItem key={state.value} value={state.value}>{state.label}</MenuItem>
                                ))}
                              </Select>
                              {errors.state_id && <FormHelperText>{errors.state_id}</FormHelperText>}
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth error={!!errors.district_id}>
                              <InputLabel>District</InputLabel>
                              <Select
                                label="District"
                                value={obj?.district_id || ""}
                                onChange={(e) => {
                                  const selectedValue = e.target.value;
                                  const selectedLabel = districts.find((option) => option.value === selectedValue)?.label;
                                  setObj({ ...obj, 
                                    district_id: selectedValue,
                                    district_name: selectedLabel,
                                    company_pincode: null,
                                    location_id: null,
                                    location_name: "",
                                  });
                                  setFirstSelection(null);
                                }}
                              >
                                {districts.map((district) => (
                                  <MenuItem key={district.value} value={district.value}>{district.label}</MenuItem>
                                ))}
                              </Select>
                              {errors.district_id && <FormHelperText>{errors.district_id}</FormHelperText>}
                            </FormControl>
                          </Grid>

                          {/* Address Fields */}
                          {["address_line_1", "address_line_2", "address_line_3"].map((field, index) => (
                            <Grid item xs={12} key={field}>
                              <FormControl fullWidth error={!!errors[field]}>
                                <TextField
                                  required
                                  fullWidth
                                  label={`Address Line ${index + 1}`}
                                  name={field}
                                  autoComplete={field}
                                  value={obj[field] || ""}
                                  onChange={(e) => setObj({ ...obj, [field]: e.target.value })}
                                  error={!!errors[field]}
                                  helperText={errors[field]}
                                />
                              </FormControl>
                            </Grid>
                          ))}

                          {/* City & Pincode */}
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth error={!!errors.location_id}>
                              <InputLabel>City</InputLabel>
                              <Select
                                label="City"
                                value={obj?.location_id || ""}
                                onChange={(e) => {
                                  const selectedValue = e.target.value;
                                  const selectedLabel = allCities.find((option) => option.value === selectedValue)?.label;
                                  if(!firstSelection) setFirstSelection("city");
                                  setObj({ ...obj, 
                                    location_id: selectedValue, 
                                    location_name: selectedLabel,
                                    ...(firstSelection === "city" ? { company_pincode: null } : {}),
                                  });
                                }}
                              >
                                {allCities.map((city) => (
                                  <MenuItem key={city.value} value={city.value}>{city.label}</MenuItem>
                                ))}
                              </Select>
                              {errors.location_id && <FormHelperText>{errors.location_id}</FormHelperText>}
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth error={!!errors.company_pincode}>
                              <InputLabel>Pincode</InputLabel>
                              <Select
                                label="Pincode"
                                value={obj?.company_pincode || ""}
                                onChange={(e) => {
                                  const selectedPincode = e.target.value;
                                  if (!firstSelection) setFirstSelection("pincode");
                                  setObj({
                                    ...obj,
                                    company_pincode: selectedPincode,
                                    ...(firstSelection === "pincode" ? { location_id: null, location_name: "" } : {}), // Clear city if first selection was pincode
                                  });
                                }}
                              >
                                {allPincodes.map((pincode) => (
                                  <MenuItem key={pincode.value} value={pincode.value}>{pincode.label}</MenuItem>
                                ))}
                              </Select>
                              {errors.company_pincode && <FormHelperText>{errors.company_pincode}</FormHelperText>}
                            </FormControl>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
              )}
            </Grid>
          )}
          <Box sx={{ mt: '2rem' }} />
          {selectedRoleData && (
            <Box sx={{ 
              display: 'flex',
              justifyContent: {md:'flex-end'},
              mt: '2rem',
            }}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleOnSubmit}
                disabled={loading}
                startIcon={
                  loading && (
                    <CircularProgress
                      sx={{ color: 'white' }}
                      size={20}
                    />
                  )
                }
              >
                {loading
                  ? 'Loading...'
                  : selectedRoleData?.display_name
                  ? `Onboard  ${selectedRoleData?.display_name}`
                  : 'Onboard Buyer'}
              </Button>
            </Box>
          )}
          <Divider sx={{ mt: '5rem' }} />
        </Box>
      </Container>
    </div>
  );
};

export default OnboardBuyer;
